import axios from 'axios';
import { API_CONFIG } from '../config/env';

class EmbedTokensService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getEmbedTokenName(): Promise<string> {
    const response = await axios.get<{ name?: string; token?: string } | string>(`${API_CONFIG.BASE_URL}/embed-tokens`, {
      headers: this.getAuthHeaders(),
    });

    if (typeof response.data === 'string') {
      return response.data;
    }

    if (response.data?.name && response.data.name.trim().length > 0) {
      return response.data.name;
    }

    if (response.data?.token && response.data.token.trim().length > 0) {
      return response.data.token;
    }

    return '';
  }

  async generateEmbedToken(): Promise<string> {
    const response = await axios.post<{ token?: string } | string>(`${API_CONFIG.BASE_URL}/embed-tokens`, {}, {
      headers: this.getAuthHeaders(),
    });

    if (typeof response.data === 'string') {
      return response.data;
    }

    return response.data?.token ?? '';
  }

  async deleteEmbedToken(): Promise<void> {
    await axios.delete(`${API_CONFIG.BASE_URL}/embed-tokens`, {
      headers: this.getAuthHeaders(),
    });
  }
}

export const embedTokensService = new EmbedTokensService();
